import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import SchedulerLogo from "../../assets/icons/scheduler360Logo.svg";

const NavHead = ({ role, handleLogoClick }) => {
  const { profile } = useSelector((state) => state.profileInfo);
  const mentorStatus = profile?.approve_status !== "accept";
  const { pathname } = useLocation();
  const isOnboardingPage = [
    "mentee-question",
    "mentor-application-form",
    "questions",
    "individual",
    "login-type",
    "mentee-form",
  ].includes(pathname.substring(1));
  const isProfileRoutes = ["profile", "help"].some((page) =>
    pathname.includes(page)
  );


  return (
    <div
      className={`site-logo cursor-pointer flex items-center space-x-3 rtl:space-x-reverse`}
      onClick={handleLogoClick}
    >
        <img
          className={"h-[80px] w-[300px]"}
          src={SchedulerLogo}
          alt="SchedulerLogo"
        ></img>
      
    </div>
  );
};

export default NavHead;
